import { render, staticRenderFns } from "./SurveySubHeader.vue?vue&type=template&id=529af72c"
import script from "./SurveySubHeader.ts?vue&type=script&lang=ts&external"
export * from "./SurveySubHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports